import { Loading } from '@arcadiapower/shrike';
import { Document, Page } from 'react-pdf';
import styled from 'styled-components';

export const PdfWrapper = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
  border: 1px solid ${props => props.theme.colors.content.secondary};
  flex-grow: 1;
  margin-bottom: 24px;
  max-width: 100%;
  overflow-x: hidden;
  z-index: 0;
`;

export const DocumentWrapper = styled(Document).attrs({ loading: <Loading /> })`
  width: 0; /* needed to make this wrapper not overflow the container */
`;

export const StyledPage = styled(Page).attrs({ loading: <Loading /> })`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
